import React from 'react';
import './CreateDBTSkeleton.scss';

const CreateDBTSkeleton = () => {
    return (
        <div className="create-dbt-skeleton">
            {/* Basic Information Section */}
            <div className="skeleton-section">
                <div className="skeleton-title"></div>

                <div className="skeleton-row">
                    <div className="skeleton-field">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-input"></div>
                    </div>
                    <div className="skeleton-field">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-input"></div>
                    </div>
                </div>

                <div className="skeleton-row">
                    <div className="skeleton-field full-width">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-textarea"></div>
                    </div>
                </div>

                <div className="skeleton-row">
                    <div className="skeleton-field">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-input"></div>
                    </div>
                    <div className="skeleton-field">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-input"></div>
                    </div>
                </div>
            </div>

            {/* Region Section */}
            <div className="skeleton-section">
                <div className="skeleton-title"></div>

                <div className="skeleton-row">
                    <div className="skeleton-field full-width">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-radio-group">
                            <div className="skeleton-radio"></div>
                            <div className="skeleton-radio"></div>
                            <div className="skeleton-radio"></div>
                            <div className="skeleton-radio"></div>
                            <div className="skeleton-radio"></div>
                        </div>
                    </div>
                </div>

                <div className="skeleton-row">
                    <div className="skeleton-field full-width">
                        <div className="skeleton-label"></div>
                        <div className="skeleton-input"></div>
                    </div>
                </div>
            </div>

            {/* Parts Table Section */}
            <div className="skeleton-section">
                <div className="skeleton-header">
                    <div className="skeleton-title"></div>
                    <div className="skeleton-button"></div>
                </div>

                <div className="skeleton-table">
                    <div className="skeleton-table-header">
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                        <div className="skeleton-th"></div>
                    </div>
                    <div className="skeleton-table-body">
                        {[1, 2, 3].map((row) => (
                            <div key={row} className="skeleton-table-row">
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                                <div className="skeleton-td"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="skeleton-actions">
                <div className="skeleton-button"></div>
                <div className="skeleton-button"></div>
            </div>
        </div>
    );
};

export default CreateDBTSkeleton;
